import { FormattedMessage } from '@99designs/common/i18n';
import { Currency } from 'common/utils/currency';
import { FormattedBudget } from 'projects/components/FormattedBudget';
import { Industries } from 'projects/util/industries';
import * as React from 'react';

export interface Props {
    brief: {
        id: string;
        fields: {
            industry: string;
            currency?: string;
        };
    };
    industries: Industries;
    category: string;
    budget?: number;
}

export default class Description extends React.Component<Props> {
    render() {
        let selection: React.ReactNode[] = [this.props.category];

        const industry = this.props.industries.find(this.props.brief.fields.industry);
        if (industry) {
            selection = selection.concat(industry);
        }

        const { budget } = this.props;
        const { currency } = this.props.brief.fields;

        if (budget) {
            const formattedBudget = (
                <FormattedBudget budget={budget} currency={currency ? currency : Currency.USD} />
            );
            selection = selection.concat(formattedBudget);
        }

        return (
            <FormattedMessage
                message={__(
                    "Based on your selection {selection} we've matched you with some awesome designers"
                )}
                values={{
                    selection: (
                        <strong>
                            {selection.map((item, index) => (
                                <span key={index}>
                                    {index !== 0 && ' / '}
                                    {item}
                                </span>
                            ))}
                        </strong>
                    ),
                }}
            />
        );
    }
}
